import { render } from "./AppLayout.vue?vue&type=template&id=4cd6c837"
const script = {}

import exportComponent from "D:\\development\\castorama\\bathroom-web2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__